import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import DeleteIcon from '@mui/icons-material/Delete';
import DeselectIcon from '@mui/icons-material/Deselect';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import SelectAllIcon from '@mui/icons-material/SelectAll';

interface Props {
  readonly selectedCount: number;
  readonly onDeleteClick: () => void;
  readonly onDeselectAllClick: () => void;
  readonly onMoveClick: () => void;
  readonly onSelectAllClick: () => void;
}

export const FilesExplorerToolbar = ({
  selectedCount,
  onDeleteClick,
  onDeselectAllClick,
  onMoveClick,
  onSelectAllClick,
}: Readonly<Props>) => (
  <Toolbar disableGutters variant="dense">
    {selectedCount > 0 ? (
      <Button
        onClick={onDeselectAllClick}
        size="small"
        startIcon={<DeselectIcon />}
      >
        Désélectionner tout
      </Button>
    ) : (
      <Button
        onClick={onSelectAllClick}
        size="small"
        startIcon={<SelectAllIcon />}
      >
        Sélectionner tout
      </Button>
    )}
    <Box sx={{ flex: 1 }} />
    {selectedCount > 0 && (
      <>
        <Button
          onClick={onMoveClick}
          size="small"
          startIcon={<DriveFileMoveIcon />}
          sx={{ mr: 1 }}
        >
          Déplacer ({selectedCount.toFixed()})
        </Button>
        <Button
          color="error"
          onClick={onDeleteClick}
          size="small"
          startIcon={<DeleteIcon />}
        >
          Supprimer ({selectedCount.toFixed()})
        </Button>
      </>
    )}
  </Toolbar>
);
